import { createFileRoute } from '@tanstack/react-router'
import { EmptyState, PageHeader } from '../../admin/ui'

export const Route = createFileRoute('/admin/audit-logs')({
  component: AuditLogs,
})

function AuditLogs() {
  return (
    <>
      <PageHeader kicker="Access" title="Audit logs" />
      <EmptyState
        title="Audit logs are not available yet"
        body="The API does not expose audit-log endpoints. Device events are visible on each device's detail page in the meantime."
      />
    </>
  )
}
